import { ButtonHTMLAttributes, DetailedHTMLProps } from "react";
import { Navbar } from "react-bootstrap";

interface props
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  label: string;
}
const ModalActionBtn: React.FC<props> = (props) => {
  return (
    <Navbar fixed="bottom" className={`mobile-place-order-btn w-100`}>
      <button
        {...props}
        className="btn-product-add-to-cart justify-content-center"
      >
        {props.label}
      </button>
    </Navbar>
  );
};

export default ModalActionBtn;
